import { useArcheAdmin } from '@/auth/hooks/useArcheAdmin';

/**
 * External-sync preview gate (client side).
 *
 * Provider sync ("External Sync") runs on staging but is not finished, so
 * for the initial production release it is limited to platform admins:
 * admins keep exercising the real flow in prod, while everyone else sees a
 * "coming soon" placeholder instead of a half-built feature they could wire
 * a real Google/Microsoft/Apple account into.
 *
 * This is a UX gate, NOT the security boundary. The boundary is
 * `requireExternalSyncAccess` in
 * `services/api-service/src/routes/arches/sync-access.ts`, which 403s every
 * `/arches/{calendar,contact-book}/sync/*` route for non-admins. The two
 * MUST agree on their audience — a client gate that admits someone the route
 * rejects produces a UI that only fails once the user has committed to an
 * OAuth flow.
 *
 * ── REMOVING THIS GATE WHEN SYNC SHIPS ───────────────────────────────────
 * Delete this file, drop the branch in `SettingsSyncSection`, and delete the
 * server guard. Client and server must be lifted together, server first.
 */
export function useExternalSyncEnabled(): boolean {
  // Platform admin only — no domain-specific roles. Matches the server
  // guard's `userContext.isAdmin` check exactly.
  return useArcheAdmin();
}
